import { FunctionComponent, useRef, useState } from 'react';
import styles from "./Reengagement.module.css";
import cn from 'classnames';
import { Image } from 'react-bootstrap';
import SidebarLayout from '../../../../../component/common/Layout/SidebarLayout/SidebarLayout';
import TextHeader from '../../../../../component/common/TextHeader/TextHeader';
import ContentTabs from '../../../../../component/common/ContentTabs/ContentTabs';
import CustomButton, { ButtonType } from '../../../../../component/common/CustomButton/CustomButton';
import { ASSESTS } from '../../../../../constant/assest';
import CampaignCard from '../../../../../component/UI/CampaignCard/CampaignCard';
import CampaignsForm from '../../../../../component/UI/CampaignsForm/CampaignsForm';
import SearchInput from '../../../../../component/common/SearchInput/SearchInput';
import FilterSelect from '../../../../../component/common/FilterSelect/FilterSelect';
import ReengagementTable from './component/ReengagementTable';
import ReengagementForm from '../../../../../component/UI/ReengagementForm/ReengagementForm';
import DeleteModal from '../../../../../component/common/DeleteModal/DeleteModal';
import { ICampaignStatus } from '../../../../../constant/enums';

const list = [
    { title: 'Its more fun with Pro', summary: 'Upgrade Now', status: ICampaignStatus.ACTIVE, tag: 'Upgrade to Pro', date: 'Feb 15, 2024', user: 'Free Members', },
]

const Reengagement: FunctionComponent = () => {

    const [activeContentTab, setActiveContentTab] = useState('Upgrade to Pro');
    const [showReengagementFormForm, setShowReengagementFormForm] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

    const formRef = useRef<HTMLDivElement | null>(null);
    const handleScrollToUpload = () => {
        setShowReengagementFormForm(true);
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <SidebarLayout>
            <div className={cn(styles.campaignsTopRow)}>
                <TextHeader
                    title={'Reengagement'}
                    summary={"Monitor and manage your referral program performance"}
                    className='mb-4'
                />
                <ContentTabs tabs={['Upgrade to Pro', 'Retention']}
                    defaultActiveTab={activeContentTab}
                    tabOnClick={(tab) => setActiveContentTab(tab)}
                    className='mb-4'
                />
                <div className={styles.anglersEngagementHeader}>
                    <div className={styles.title}>
                        <span className={styles.header}>Upgrade to Pro</span> Select an existing campaign or create a new one
                    </div>
                    <CustomButton
                        className={styles.addNewContentBtn}
                        btnType={ButtonType.GREEN}
                        onClick={handleScrollToUpload}
                    >
                        <Image src={ASSESTS.ADD} alt={'Download'} /> Add New Content
                    </CustomButton>
                </div>
                <div className={styles.campaignsCardsRow}>
                    {list.map((item, index) => (
                        <CampaignCard
                            key={`${item.title}-${index}`}
                            className={styles.campaignsOverViewCard}
                            icon={<Image src={ASSESTS.FISH} alt='Fish' width={24} height={22} />}
                            title={item.title}
                            status={item.status}
                            tag={item.tag}
                            date={item.date}
                            user={item.user}
                            onDelete={() => setShowDeleteModal(true)}
                        />
                    ))}
                </div>
            </div>
            <div ref={formRef} className={styles.campaignsFormRow}>
                {showReengagementFormForm && <ReengagementForm />}
            </div>
            <div className={cn(styles.campaignsBottomRow)}>
                <TextHeader
                    title={'Fishinity Accounts'}
                    className='mb-3'
                />
                <div className={styles.tableFilter}>
                    <SearchInput placeholder='Search subscriptions...' className={styles.proAccountsSearch} />
                    <div className={cn(styles.tableFilter, styles.tableFilterCols)}>
                        <div className={styles.selectFilter}>
                            <FilterSelect
                                options={[
                                    { value: "AllStatus", label: "All Status" },
                                    { value: "active", label: "Active" },
                                    { value: "inactive", label: "Inactive" },
                                    { value: "cancelled", label: "Cancelled" },
                                ]}
                                onSelect={(value: string): void => {
                                   
                                }}
                                placeholder={'All Status'}
                            />
                        </div>
                    </div>
                </div>
                <ReengagementTable />
            </div>
            <DeleteModal 
                title={'Delete Compaing'}
                showModal={showDeleteModal}
                onClose={() => setShowDeleteModal(false)} 
                bodyText={'Are you sure want to delete this Item?'} 
                onDelete={() => setShowDeleteModal(false)}
            />
        </SidebarLayout>
    );
};

export default Reengagement;